import type { User } from '../types/users';
import type { OutTypes } from './schedules';

export default function (
  users:          User[] | undefined,
  groups:         OutTypes.group[],
  importErrors:   string[],
  importWarnings: string[]
) {
  // add all persons to a set to remove duplicates
  const personSet: Map<number, OutTypes.person> = new Map();

  /*
    The reference to the group is different that the one in the primary_groups array.
    To solve this we create a map of all groups and use the id of the group as key. If
    the id is not found in the map, try to find a group with the same name.
  */
  const groupSet = new Map(groups.map(x => [x.displayName!, x.ids!]));

  users?.filter(x => x.role === 1).forEach(user => {
    const person = {
      ids:       user.id.toString(),
      firstName: user.first_name,
      lastName:  user.last_name,
      group:     user.current_primary_group?.id?.toString(),
      ...user.email && {
        emails: [
          {
            value: user.email,
            type:  'organization'
          }
        ]
      }
    } satisfies OutTypes.person;

    if (user.current_primary_group) {
      const { id, name } = user.current_primary_group;
      if (groupSet.get(name.toString()) != person.group) {
        importWarnings.push(`The group of the user ${person.firstName} ${person.lastName} is not the same as the group in the primary_groups array.`);
        person.group = groupSet.get(name.toString()) ?? person.group;
      }
    }


    personSet.set(user.id, person);
  });

  return Array.from(personSet.values());
}
